import React, { useEffect, useState } from 'react';
import createResponse from '@zr/utilities/api/createResponse';
import { handleJobApplyEvent } from '@zr/utilities/gtm/jobApply';
import LoadingAnimation from '@zr/components/LoadingAnimation';

import { ApplyData } from '../../../../types';
import { STRING_PLEASE_WAIT } from '../../../../labels';

interface PerformApplyProps {
  applyData: ApplyData;
  onScreenTypeFinish: () => void;
  setApplyData: (arg0: Record<string, unknown>) => void;
  setIsLoading?: (arg0: boolean) => void;
}

function PerformApply({
  applyData,
  onScreenTypeFinish,
  setApplyData,
  setIsLoading,
}: PerformApplyProps): JSX.Element {
  const [error, setError] = useState(null);
  if (error) {
    throw error;
  }

  const responseData = {
    applyMethod: applyData.method,
    encQuizId: applyData.encryptedQuizId,
    lvk: applyData.listingVersionKey,
    placementId: applyData.placementId,
    encPlacementId: applyData.encPlacementId,
  };

  useEffect(() => {
    let ignore = false;
    async function postData() {
      const response = await createResponse(responseData);
      if (response.success && !ignore) {
        // Trigger GTM event
        handleJobApplyEvent(response);

        // update applyData with encrypted_response_id
        setApplyData({ ...applyData, encrypted_response_id: response.encrypted_response_id });

        // Do what comes next
        onScreenTypeFinish();
      }
    }

    // `setIsLoading(true)` so that we can disable the close button while the
    // screen is processing/loading
    setIsLoading?.(true);

    // ErrorBoundary does not catch errors for aync code, so catch here and rethrow
    postData().catch((e) => {
      if (!ignore) {
        setError(e);
      }
    });

    // Abort fetch if the component re-renders prematurely
    return () => {
      ignore = true;
    };

  // This is so that we do not call the createResponse endpoint twice
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingAnimation loadingMessage={STRING_PLEASE_WAIT} />;
}

export default PerformApply;
